/*
 * @Description: 路由跳转控制中心
 * @Author: 任录
 * @Date: 2019-07-22 15:13:52
 * @LastEditTime: 2019-07-26 22:38:03
 */

import Vue from 'vue'
import Router from 'vue-router'

import home from '../views/home/index.vue'
import homeNoFilter from '../views/home/index-no-filter.vue'
import detail from '../views/detail/index.vue'
import honor from '../views/detail/honor/index.vue'
import honorDetail from '../views/detail/honor/detail.vue'
import building from '../views/detail/building/index.vue'
import buildingDetail from '../views/detail/building/detail.vue'
import inscription from '../views/detail/inscription/index.vue'
import inscriptionDetail from '../views/detail/inscription/detail.vue'
import hero from '../views/detail/hero/index.vue'
import heroDetail from '../views/detail/hero/detail.vue'
import booking from '../views/booking/index.vue'
import suggestion from '../views/public/suggestion.vue'
import columnDetail from '../views/column/index.vue'
import contact from '../views/contact/index.vue'
import notice from '../views/notice/index.vue'
import noticeDetail from '../views/notice/detail.vue'
import lastestNews from '../views/lastest-news/index.vue'
import personalMemorial from '../views/commemorate/personal.vue'
import memorizeHero from '../views/commemorate/heroes.vue'
import monument from '../views/commemorate/monument.vue'
import rmjz from '../views/detail/rongmei/index.vue'
import dtdl from '../views/detail/ditu/index.vue'

//memorial
Vue.use(Router)

const children = []

const router = new Router({
	mode: 'history',
	routes: [
		
		{
			path: '/',
			name: '',
			component: home
		},
		{
			path: '/noFilter',
			name: '',
			component: homeNoFilter
		},
		{
			path: '/detail',
			name: '',
			component: detail
		},
		{
			path: '/honor',
			name: '',
			component: honor
		},
		{
			path: '/detail/honor',
			name: '',
			component: honorDetail
		},
		{
			path: '/building',
			name: '',
			component: building
		},
		{
			path: '/detail/building',
			name: '',
			component: buildingDetail
		},
		{
			path: '/inscription',
			name: '',
			component: inscription
		},
		{
			path: '/detail/inscription',
			name: '',
			component: inscriptionDetail
		},
		{
			path: '/heroes',
			name: '',
			component: hero
		},
		{
			path: '/detail/hero',
			name: '',
			component: heroDetail
		},
		{
			path: '/booking',
			name: '',
			component: booking
		},
		{
			path: '/suggestion',
			name: '',
			component: suggestion
		},
		{
			path: '/col/detail',
			name: '',
			component: columnDetail
		},
		{
			path: '/notice',
			name: '',
			component: notice
		},
		{
			path: '/notice/detail',
			name: '',
			component: noticeDetail
		},
		{
			path: '/contact',
			name: '',
			component: contact
		},
		{
			path: '/lastestNews',
			name: '',
			component: lastestNews
		},
		{
			path: '/memorial/personal',
			name: '',
			component: personalMemorial
		},
		{
			path: '/memorial/public',
			name: '',
			component: monument
		},
		{
			path: '/memorize/heroes',
			name: '',
			component: memorizeHero
		},
		{
			path: '/rmjz',
			name: '',
			component: rmjz
		},
		{
			path: '/dtdl',
			name: '',
			component: dtdl
		},
		
	]
})

router.beforeEach((to, from, next) => {
	window.scroll(0, 0);
	next();
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js